/**
 * Logs a warning ONLY in non-production builds.
 * Used to surface unexpected runtime conditions (corrupt localStorage,
 * non-JSON server error bodies, etc.) during development without
 * exposing internals or noise in the production console.
 *
 * In CRA, NODE_ENV is replaced at build time with "development" or "production".
 */
export const devWarn = (...args) => {
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.warn(...args);
  }
};
